function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'rating';

/**
 * This is the component description.
 */
const Rating = ({
  id,
  className: userClassName,
  style,
  value,
  name,
  ratingId,
  hover,
  setHover,
  validate,
  activeBackgroundColor,
  inactiveBackgroundColor,
  showRatingValue
  // ...otherProps
}) => {
  const [field] = useField({
    name,
    validate
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, `x-${activeBackgroundColor}`, `y-${inactiveBackgroundColor}`].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: ratingId,
    onMouseEnter: () => setHover(value),
    onMouseLeave: () => setHover(null)
  }, showRatingValue && /*#__PURE__*/React.createElement("span", {
    className: "s-2 x-metadata c-x"
  }, value), /*#__PURE__*/React.createElement("span", {
    className: ['icon', value <= (hover || Number(field.value)) ? 'c-x' : 'c-hard-y'].filter(e => e).join(' ')
  }, "[")), /*#__PURE__*/React.createElement("input", _extends({}, field, {
    type: "radio",
    id: ratingId,
    name: name,
    value: value
  })));
};
Rating.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The value of each an every rating star
   */
  value: PropTypes.number,
  /**
   * The current hover value
   */
  hover: PropTypes.number,
  /**
   * Function to update the hover value
   */
  setHover: PropTypes.func,
  /**
   * Unique Id for each rating star
   */
  ratingId: PropTypes.string,
  /**
   * Name of the rating input
   */
  name: PropTypes.string,
  /**
   * The start rating backgriund color when hovered or clicked
   */
  activeBackgroundColor: PropTypes.string,
  /**
   * The start rating backgriund color when not hovered and not clicked
   */
  inactiveBackgroundColor: PropTypes.string,
  /**
   * Determines if the rating start value should be shown
   */
  showRatingValue: PropTypes.bool,
  /**
   * The rating field validator function
   */
  validate: PropTypes.func
};
Rating.defaultProps = {
  activeBackgroundColor: 'interactive',
  inactiveBackgroundColor: 'background-inputs',
  showRatingValue: false
};
export default Rating;